<nav
  class="header-shell sticky top-0 w-full bg-white"
  [class.z-20]="!toolbarMenuOpen && !searchOpen"
  [class.header-shell--elevated]="toolbarMenuOpen || searchOpen"
  [class.header-shell--team-inbox]="isTeamInbox"
>
  <div class="header-inner flex items-center justify-between py-3">
    <div class="flex items-center gap-2">
      <button
        type="button"
        (click)="toggleMobileNavigation()"
        [attr.aria-expanded]="sidebarPanel.mobileOpen()"
        [attr.aria-label]="'MENU.OPEN_NAVIGATION' | translate"
        class="header-tool-btn header-mobile-menu sm:hidden"
        aria-controls="drawer-navigation"
      >
        <app-sidebar-icon name="menu" [size]="22" [strokeWidth]="1.75"></app-sidebar-icon>
      </button>
      <div class="header-brand">
        <a
          [routerLink]="companyBrandLink"
          class="header-brand__rail-slot"
          [attr.aria-label]="companyName || ('COMPANY.FORM.LOGO' | translate)"
          [attr.title]="companyName || null"
        >
          <span
            class="header-brand__company"
            [style.--brand-color]="companyBrandColor"
          >
            <img
              *ngIf="companyLogoUrl"
              [src]="companyLogoUrl"
              [alt]="companyName || 'Company logo'"
              class="header-brand__company-img"
            />
            <span *ngIf="!companyLogoUrl" class="header-brand__company-initial">
              {{ companyInitial }}
            </span>
            <img
              *ngIf="myAvatarUrl"
              [src]="myAvatarUrl"
              alt=""
              class="header-brand__my-avatar"
              [matTooltip]="'HEADER.MY_AVATAR_TOOLTIP' | translate"
              matTooltipPosition="below"
            />
          </span>
        </a>
        <a routerLink="/" class="header-brand__app" aria-label="Dashy">
          <img [src]="appLogoImage" alt="Dashy" class="header-brand__logo" />
        </a>
      </div>

      <!-- Global search — inline bar with anchored dropdown -->
      <div
        *ngIf="showGlobalSearch"
        class="header-search-slot"
        [class.header-search-slot--open]="searchOpen"
        [class.header-search-slot--mobile]="mobileSearchOpen"
      >
        <app-global-search
          (openChange)="searchOpen = $event"
        ></app-global-search>
      </div>
    </div>

    <div class="header-actions flex items-center gap-2 sm:gap-3">
      <!-- Trial countdown now lives in the full-width app-trial-banner above the app frame. -->

      <!-- Store open / closed: first of the actions, just left of the language menu -->
      <app-store-status-button></app-store-status-button>

      <!-- Language menu -->
      <div class="relative header-toolbar-trigger hidden sm:flex items-center">
        <button
          type="button"
          class="header-lang-btn"
          [class.header-lang-btn--active]="showLangMenu"
          (click)="toggleLangMenu($event)"
          [matTooltip]="'HEADER.TOOLBAR.LANGUAGE' | translate"
          matTooltipClass="cl-action-tooltip"
          [matTooltipShowDelay]="200"
          matTooltipPosition="below"
          [matTooltipDisabled]="showLangMenu"
          [attr.aria-expanded]="showLangMenu"
          aria-haspopup="menu"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.75"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10" />
            <path
              d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
            />
          </svg>
          <span class="header-lang-btn__label">{{ currentLangLabel }}</span>
          <svg
            class="header-lang-btn__chevron"
            [class.header-lang-btn__chevron--open]="showLangMenu"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        <div
          *ngIf="showLangMenu"
          class="header-dropdown header-lang-menu header-toolbar-menu"
          role="menu"
        >
          <div class="header-dropdown__title">
            {{ "HEADER.TOOLBAR.LANGUAGE" | translate }}
          </div>
          <div class="header-dropdown__list">
            <button
              *ngFor="let lang of languages"
              type="button"
              role="menuitem"
              class="header-dropdown__item header-lang-item"
              [class.header-lang-item--active]="lang.code === getCurrentLang()"
              (click)="selectLanguage(lang.code)"
            >
              <span>{{ getLanguageLabel(lang.code) }}</span>
              <svg
                *ngIf="lang.code === getCurrentLang()"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Phones: the search bar opens full width under the header -->
      <button
        *ngIf="showGlobalSearch"
        type="button"
        class="header-tool-btn header-mobile-search sm:hidden"
        [class.header-tool-btn--active]="mobileSearchOpen"
        (click)="toggleMobileSearch()"
        [attr.aria-expanded]="mobileSearchOpen"
        [attr.aria-label]="'HEADER.TOOLBAR.SEARCH' | translate"
      >
        <app-sidebar-icon name="search" [size]="20" [strokeWidth]="1.75"></app-sidebar-icon>
      </button>

      <div class="header-toolbar flex items-center gap-0.5 sm:gap-1">
        <!-- Notifications -->
        <div
          *ngIf="showNotificationBell"
          class="relative header-toolbar-trigger"
        >
          <button
            #notificationToggle
            type="button"
            (click)="toggleNotifications()"
            class="notification-toggle-btn header-tool-btn"
            [class.header-tool-btn--active]="showNotifications"
            [attr.aria-label]="'NOTIFICATION.PAGE.TITLE' | translate"
            [attr.aria-expanded]="showNotifications"
            aria-controls="header-notification-panel"
            [matTooltip]="'NOTIFICATION.PAGE.TITLE' | translate"
            matTooltipClass="cl-action-tooltip"
            [matTooltipShowDelay]="200"
            matTooltipPosition="below"
          >
            <app-sidebar-icon name="bell" [size]="20" [strokeWidth]="1.75"></app-sidebar-icon>
            <span
              *ngIf="actionRequiredCount > 0"
              class="absolute top-0.5 right-0.5 inline-flex items-center justify-center min-w-[16px] h-4 px-1 text-[10px] font-black leading-none text-white bg-red-600 rounded-full"
              [attr.aria-label]="
                (actionRequiredCount === 1
                  ? 'NOTIFICATION.PAGE.ACTION_REQUIRED_ONE'
                  : 'NOTIFICATION.PAGE.ACTION_REQUIRED_MANY'
                ) | translate
              "
              >!</span
            >
            <span
              *ngIf="actionRequiredCount === 0 && unreadCount > 0"
              class="absolute top-0.5 right-0.5 inline-flex items-center justify-center min-w-[16px] h-4 px-1 text-[9px] font-bold leading-none text-white bg-red-500 rounded-full"
              >{{ unreadCount > 99 ? "99+" : unreadCount }}</span
            >
          </button>
        </div>

        <app-header-guide-button></app-header-guide-button>

        <app-announcement-inbox-button></app-announcement-inbox-button>

        <!-- Settings -->
        <button
          *ngIf="showCompanyMenuDropdown"
          type="button"
          class="header-tool-btn header-toolbar-trigger"
          (click)="openSettings()"
          [matTooltip]="'HEADER.TOOLBAR.SETTINGS' | translate"
          matTooltipClass="cl-action-tooltip"
          [matTooltipShowDelay]="200"
          matTooltipPosition="below"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path
              d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
            />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </button>
      </div>

      <!-- Company menu (Brevo-style chip + dropdown) -->
      <div
        *ngIf="showCompanyMenuDropdown"
        class="relative header-toolbar-trigger hidden sm:flex items-center"
      >
        <button
          type="button"
          class="header-company-chip"
          [class.header-company-chip--active]="showCompanyMenu"
          (click)="toggleCompanyMenu($event)"
          [matTooltip]="'HEADER.COMPANY_MENU.TOOLTIP' | translate"
          matTooltipClass="cl-action-tooltip"
          [matTooltipShowDelay]="200"
          matTooltipPosition="below"
          [matTooltipDisabled]="showCompanyMenu"
          [attr.aria-label]="
            companyName || ('HEADER.COMPANY_MENU.TOOLTIP' | translate)
          "
          [attr.aria-expanded]="showCompanyMenu"
          aria-haspopup="menu"
        >
          <span
            class="header-company-chip__logo"
            [style.--brand-color]="companyBrandColor"
          >
            <img
              *ngIf="companyLogoUrl"
              [src]="companyLogoUrl"
              [alt]="companyName || 'Company logo'"
            />
            <span
              *ngIf="!companyLogoUrl"
              class="header-company-chip__initial"
              >{{ companyInitial }}</span
            >
          </span>
          <span *ngIf="companyName" class="header-company-chip__name">{{
            companyName
          }}</span>
          <svg
            class="header-company-chip__chevron"
            [class.header-company-chip__chevron--open]="showCompanyMenu"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        <div
          *ngIf="showCompanyMenu"
          class="header-dropdown header-company-menu header-toolbar-menu"
          role="menu"
        >
          <div class="header-company-menu__head">
            <span
              class="header-company-chip__logo header-company-menu__logo"
              [style.--brand-color]="companyBrandColor"
            >
              <img
                *ngIf="companyLogoUrl"
                [src]="companyLogoUrl"
                [alt]="companyName || 'Company logo'"
              />
              <span
                *ngIf="!companyLogoUrl"
                class="header-company-chip__initial"
                >{{ companyInitial }}</span
              >
            </span>
            <div class="header-company-menu__identity">
              <div class="header-company-menu__name">{{ companyName }}</div>
              <div class="header-company-menu__hint">
                {{ "HEADER.COMPANY_MENU.SUBTITLE" | translate }}
              </div>
            </div>
          </div>
          <div class="header-dropdown__list">
            <button
              *ngFor="let item of visibleCompanyMenu"
              type="button"
              class="header-dropdown__item"
              role="menuitem"
              (click)="navigateFromToolbar(item.path)"
            >
              <i
                *ngIf="item.brandIcon === 'meta'"
                class="fa-brands fa-meta header-dropdown__brand-icon header-dropdown__brand-icon--meta"
                aria-hidden="true"
              ></i>
              <i
                *ngIf="item.brandIcon === 'whatsapp'"
                class="fa-brands fa-whatsapp header-dropdown__brand-icon header-dropdown__brand-icon--wa"
                aria-hidden="true"
              ></i>
              <app-sidebar-icon
                *ngIf="!item.brandIcon"
                [name]="item.icon"
                [size]="16"
              ></app-sidebar-icon>
              <span>{{ item.labelKey | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Company branding only (no menu items for this user) -->
      <div
        *ngIf="!showCompanyMenuDropdown && (companyName || companyLogoUrl)"
        class="header-company-chip header-company-chip--static hidden sm:inline-flex items-center"
        [attr.aria-label]="
          companyName || ('HEADER.COMPANY_MENU.TOOLTIP' | translate)
        "
        [attr.title]="companyName || null"
      >
        <span
          class="header-company-chip__logo"
          [style.--brand-color]="companyBrandColor"
        >
          <img
            *ngIf="companyLogoUrl"
            [src]="companyLogoUrl"
            [alt]="companyName || 'Company logo'"
          />
          <span *ngIf="!companyLogoUrl" class="header-company-chip__initial">{{
            companyInitial
          }}</span>
        </span>
        <span *ngIf="companyName" class="header-company-chip__name">{{
          companyName
        }}</span>
      </div>

      <app-dropdown-user></app-dropdown-user>
    </div>

    <!-- Mobile language selector -->
    <div class="header-mobile-lang sm:hidden relative header-toolbar-trigger">
      <button
        type="button"
        class="header-mobile-lang__btn"
        [class.header-mobile-lang__btn--active]="showLangMenu"
        (click)="toggleLangMenu($event)"
        [attr.aria-label]="'HEADER.TOOLBAR.LANGUAGE' | translate"
        [attr.aria-expanded]="showLangMenu"
        aria-haspopup="menu"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <path
            d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
          />
        </svg>
      </button>

      <div
        *ngIf="showLangMenu"
        class="header-dropdown header-lang-menu"
        role="menu"
      >
        <div class="header-dropdown__title">
          {{ "HEADER.TOOLBAR.LANGUAGE" | translate }}
        </div>
        <div class="header-dropdown__list">
          <button
            *ngFor="let lang of languages"
            type="button"
            role="menuitem"
            class="header-dropdown__item header-lang-item"
            [class.header-lang-item--active]="lang.code === getCurrentLang()"
            (click)="selectLanguage(lang.code)"
          >
            <span>{{ getLanguageLabel(lang.code) }}</span>
            <svg
              *ngIf="lang.code === getCurrentLang()"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>

<!-- Notification Dropdown -->
<div
  *ngIf="showNotifications && showNotificationBell"
  id="header-notification-panel"
  class="notification-dropdown notif-panel"
  role="dialog"
  [attr.aria-label]="'NOTIFICATION.PAGE.TITLE' | translate"
  [ngStyle]="notificationDropdownStyle"
  (keydown.escape)="closeNotifications(true)"
>
  <!-- Panel Header -->
  <div class="notif-panel__header">
    <div class="notif-panel__title-row">
      <div class="notif-panel__title">
        <h3>{{ "NOTIFICATION.PAGE.TITLE" | translate }}</h3>
        <span *ngIf="unreadCount > 0" class="notif-panel__count">{{
          unreadCount > 99 ? "99+" : unreadCount
        }}</span>
      </div>
      <label class="notif-switch">
        <input
          type="checkbox"
          [checked]="unreadOnly"
          (change)="toggleUnreadOnly()"
        />
        <span class="notif-switch__track" aria-hidden="true"></span>
        <span class="notif-switch__label">{{
          "NOTIFICATION.PAGE.UNREAD_ONLY" | translate
        }}</span>
      </label>
    </div>
    <div class="notif-panel__actions">
      <button
        type="button"
        class="notif-panel__mark-all"
        (click)="markAllAsRead()"
        [disabled]="markingAllAsRead"
        [matTooltip]="'NOTIFICATION.PAGE.MARK_ALL_READ' | translate"
        matTooltipClass="cl-action-tooltip"
        [matTooltipShowDelay]="200"
        matTooltipPosition="below"
      >
        <svg
          *ngIf="!markingAllAsRead"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M18 6 7 17l-5-5" />
          <path d="m22 10-7.5 7.5L13 16" />
        </svg>
        <span
          *ngIf="markingAllAsRead"
          class="notif-spinner notif-spinner--xs"
        ></span>
        <span class="notif-panel__action-label">{{
          "NOTIFICATION.PAGE.MARK_ALL_READ" | translate
        }}</span>
      </button>
      <button
        type="button"
        class="notif-panel__manage"
        (click)="openConfigModal()"
        [matTooltip]="'NOTIFICATION.PAGE.MANAGE' | translate"
        matTooltipClass="cl-action-tooltip"
        [matTooltipShowDelay]="200"
        matTooltipPosition="below"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path
            d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
          />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <span class="notif-panel__action-label">{{
          "NOTIFICATION.PAGE.MANAGE" | translate
        }}</span>
      </button>
    </div>
  </div>

  <button
    *ngIf="actionRequiredCount > 0"
    type="button"
    class="notif-panel__payment-action"
    (click)="openPaymentActions($event)"
  >
    <span class="notif-panel__payment-action-icon" aria-hidden="true">!</span>
    <span>
      <strong
        >{{ actionRequiredCount }}
        {{
          (actionRequiredCount === 1
            ? "NOTIFICATION.PAGE.ACTION_REQUIRED_ONE"
            : "NOTIFICATION.PAGE.ACTION_REQUIRED_MANY"
          ) | translate
        }}</strong
      >
      <small *ngIf="paymentAction?.referenceId">
        {{ paymentAction?.referenceId }}
      </small>
      <small>{{ "NOTIFICATION.PAGE.ACTION_REQUIRED_HINT" | translate }}</small>
    </span>
  </button>

  <!-- Scrollable List -->
  <div class="notif-panel__list">
    <!-- Notification Row -->
    <div
      *ngFor="let notification of notifications"
      (click)="markAsRead(notification)"
      role="button"
      tabindex="0"
      (keydown.enter)="markAsRead(notification)"
      class="notif-row"
      [class.notif-row--unread]="!notification.readStatus"
      [class.notif-row--action]="
        notification.actionRequired &&
        !notification.resolvedAt &&
        !notification.readStatus
      "
    >
      <!-- Type Icon -->
      <div class="notif-row__avatar">
        <span
          *ngIf="!notification.readStatus"
          class="notif-row__unread-dot"
          aria-hidden="true"
        ></span>
        <div
          class="notif-row__icon"
          [ngClass]="
            'notif-row__icon--' +
            getNotificationTone(notification.type, notification)
          "
        >
          <ng-container [ngSwitch]="notification.type">
            <!-- a sheet with an arrow into it: any import (products, contacts, vouchers…) -->
            <svg
              *ngSwitchCase="'IMPORT_JOB_FINISHED'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <path d="M14 2v6h6" />
              <path d="M12 18v-6" />
              <path d="m9 15 3 3 3-3" />
            </svg>
            <svg
              *ngSwitchCase="'PAYMENT_CAPTURE_REQUIRED'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M12 9v4" />
              <path d="M12 17h.01" />
              <path
                d="M10.3 3.8 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.8a2 2 0 0 0-3.4 0Z"
              />
            </svg>
            <svg
              *ngSwitchCase="'TEMPLATE_APPROVED'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <path d="m9 11 3 3L22 4" />
            </svg>
            <svg
              *ngSwitchCase="'TEMPLATE_REJECTED'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m15 9-6 6M9 9l6 6" />
            </svg>
            <svg
              *ngSwitchCase="'ORDER'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
              <path d="M3 6h18" />
              <path d="M16 10a4 4 0 0 1-8 0" />
            </svg>
            <svg
              *ngSwitchCase="'CONTACT_UPLOAD_BATCH_FINISHED'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="m16 11 2 2 4-4" />
            </svg>
            <svg
              *ngSwitchCase="'PENDING_MESSAGE_EXPORT_FINISHED'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              />
              <path d="M14 2v6h6M12 12v6M9 15l3 3 3-3" />
            </svg>
            <svg
              *ngSwitchCase="'IMAGE'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
              <circle cx="9" cy="9" r="2" />
              <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
            </svg>
            <svg
              *ngSwitchCase="'VIDEO'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path
                d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"
              />
              <rect x="2" y="6" width="14" height="12" rx="2" />
            </svg>
            <svg
              *ngSwitchCase="'DOCUMENT'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path
                d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
              />
              <path d="M14 2v4a2 2 0 0 0 2 2h4" />
              <path d="M10 9H8M16 13H8M16 17H8" />
            </svg>
            <svg
              *ngSwitchCase="'AUDIO'"
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
              <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
              <path d="M12 19v3" />
            </svg>
            <svg
              *ngSwitchDefault
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22z" />
            </svg>
          </ng-container>
        </div>
      </div>

      <!-- Row Content -->
      <div class="notif-row__content">
        <div class="notif-row__title">
          {{ getNotificationTitle(notification) }}
        </div>
        <div
          *ngIf="getNotificationSender(notification)"
          class="notif-row__sender"
        >
          {{ getNotificationSender(notification) }}
        </div>
        <div class="notif-row__meta">
          <span class="notif-row__time">{{
            getNotificationTime(notification.createdAtUtc, notification.createdAt)
          }}</span>
          <ng-container
            *ngIf="
              (notification.type === 'TEMPLATE_APPROVED' ||
                notification.type === 'TEMPLATE_REJECTED') &&
              getTemplateName(notification.description)
            "
          >
            <span class="notif-row__meta-sep" aria-hidden="true">&middot;</span>
            <span class="notif-row__meta-chip">
              <span class="notif-row__meta-chip-dot" aria-hidden="true"></span>
              <span class="notif-row__meta-chip-text">{{
                getTemplateName(notification.description)
              }}</span>
            </span>
          </ng-container>
        </div>

        <!-- Template preview (approved / rejected) -->
        <ng-container
          *ngIf="
            notification.type === 'TEMPLATE_APPROVED' ||
              notification.type === 'TEMPLATE_REJECTED';
            else standardBody
          "
        >
          <div class="notif-bubble notif-bubble--block">
            <div
              *ngIf="getTemplateHeaderType(notification.description)"
              class="notif-template__media"
              [ngSwitch]="getTemplateHeaderType(notification.description)"
            >
              <svg
                *ngSwitchCase="'IMAGE'"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                <circle cx="9" cy="9" r="2" />
                <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
              </svg>
              <svg
                *ngSwitchCase="'VIDEO'"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path
                  d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"
                />
                <rect x="2" y="6" width="14" height="12" rx="2" />
              </svg>
              <svg
                *ngSwitchCase="'DOCUMENT'"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path
                  d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                />
                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
              </svg>
            </div>
            <div
              class="notif-template__text"
              [class.notif-template__text--clamped]="
                !isExpanded(notification.id)
              "
              [innerHTML]="getCleanTemplateContent(notification.description)"
            ></div>
            <div
              *ngIf="getTemplateButtons(notification.description).length > 0"
              class="notif-template__buttons"
            >
              <div
                *ngFor="let btn of getTemplateButtons(notification.description)"
                class="notif-template__btn"
              >
                <svg
                  *ngIf="btn.type === 'PHONE_NUMBER'"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  />
                </svg>
                <svg
                  *ngIf="btn.type === 'URL'"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                  />
                  <path
                    d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                  />
                </svg>
                <span>{{ btn.text }}</span>
              </div>
            </div>
            <button
              *ngIf="
                getCleanTemplateContent(notification.description).length > 150
              "
              type="button"
              class="notif-template__expand"
              (click)="toggleExpand($event, notification.id)"
            >
              <span>{{
                (isExpanded(notification.id)
                  ? "NOTIFICATION.PAGE.SEE_LESS"
                  : "NOTIFICATION.PAGE.SEE_MORE"
                ) | translate
              }}</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
                [class.notif-template__expand-icon--open]="
                  isExpanded(notification.id)
                "
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>
          </div>
        </ng-container>

        <!-- Standard body -->
        <ng-template #standardBody>
          <div
            class="notif-bubble"
            *ngIf="shouldShowNotificationBody(notification)"
          >
            <ng-container
              *ngFor="
                let part of getNotificationDescriptionParts(
                  notification.description,
                  notification.type
                )
              "
            >
              <span
                *ngIf="part.label; else notificationTextPart"
                class="notif-bubble__label"
              >
                {{ part.text }}
              </span>
              <ng-template #notificationTextPart>{{ part.text }}</ng-template>
            </ng-container>
          </div>
          <div
            *ngIf="
              notification.mediaItems && notification.mediaItems.length > 0
            "
            class="notif-row__attachments"
          >
            <ng-container *ngFor="let item of notification.mediaItems">
              <!-- Image thumbnail -->
              <div
                *ngIf="item.mimeType?.startsWith('image/'); else fileChip"
                class="notif-thumb"
              >
                <div *ngIf="item.loading" class="notif-thumb__state">
                  <span class="notif-spinner notif-spinner--xs"></span>
                </div>
                <img
                  *ngIf="!item.loading && !item.error"
                  [src]="item.safeUrl"
                  alt="Notification media"
                />
                <div
                  *ngIf="item.error"
                  class="notif-thumb__state notif-thumb__state--error"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 8v4M12 16h.01" />
                  </svg>
                </div>
              </div>
              <!-- File attachment chip -->
              <ng-template #fileChip>
                <div
                  class="notif-attachment"
                  [class.notif-attachment--error]="item.error"
                  [title]="item.fileName"
                >
                  <span
                    *ngIf="item.loading"
                    class="notif-spinner notif-spinner--xs"
                  ></span>
                  <svg
                    *ngIf="!item.loading"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"
                    />
                  </svg>
                  <span class="notif-attachment__name">{{
                    item.fileName
                  }}</span>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Loading skeletons (initial load) -->
    <ng-container *ngIf="loadingNotifications && notifications.length === 0">
      <div *ngFor="let s of [0, 1, 2]" class="notif-skeleton">
        <span class="notif-skeleton__icon"></span>
        <span class="notif-skeleton__lines">
          <span class="notif-skeleton__line notif-skeleton__line--short"></span>
          <span class="notif-skeleton__line"></span>
        </span>
      </div>
    </ng-container>

    <!-- Empty State -->
    <div
      *ngIf="notifications.length === 0 && !loadingNotifications"
      class="notif-empty"
    >
      <div class="notif-empty__icon">
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M10.268 21a2 2 0 0 0 3.464 0" />
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        </svg>
      </div>
      <p class="notif-empty__title">
        {{ "NOTIFICATION.PAGE.EMPTY" | translate }}
      </p>
      <p class="notif-empty__hint">
        {{ "NOTIFICATION.PAGE.EMPTY_HINT" | translate }}
      </p>
    </div>

    <!-- Load More -->
    <button
      *ngIf="notifications.length < totalElements && !loadingNotifications"
      type="button"
      class="notif-load-more"
      (click)="loadMoreNotifications($event)"
    >
      {{ "NOTIFICATION.PAGE.SHOW_MORE" | translate }}
    </button>

    <div
      *ngIf="loadingNotifications && notifications.length > 0"
      class="notif-panel__loading"
    >
      <span class="notif-spinner"></span>
    </div>
  </div>

</div>

<!-- Notification Config Modal -->
<div
  *ngIf="showConfigModal"
  class="notif-config-overlay"
  (click)="closeConfigModal()"
>
  <div
    class="notif-config"
    (click)="$event.stopPropagation()"
    role="dialog"
    aria-modal="true"
  >
    <!-- Modal Header -->
    <div class="notif-config__header">
      <div class="notif-config__heading">
        <span class="notif-config__heading-icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M10.268 21a2 2 0 0 0 3.464 0" />
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          </svg>
        </span>
        <div>
          <h2>{{ "NOTIFICATION.CONFIG.TITLE" | translate }}</h2>
          <p>{{ "NOTIFICATION.CONFIG.SUBTITLE" | translate }}</p>
        </div>
      </div>
      <button
        type="button"
        class="notif-panel__icon-btn"
        (click)="closeConfigModal()"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="notif-config__body">
      <div *ngIf="loadingConfig" class="notif-panel__loading">
        <span class="notif-spinner"></span>
      </div>
      <div *ngIf="!loadingConfig" class="notif-config__list">
        <label
          *ngFor="let type of visibleNotificationTypes"
          class="notif-config__row"
          [class.notif-config__row--on]="isTypeEnabled(type)"
        >
          <span class="notif-config__row-label">{{
            "NOTIFICATION.TYPE." + type | translate
          }}</span>
          <span class="notif-switch notif-switch--solo">
            <input
              type="checkbox"
              [checked]="isTypeEnabled(type)"
              (change)="toggleType(type)"
            />
            <span class="notif-switch__track" aria-hidden="true"></span>
          </span>
        </label>

        <div class="notif-config__section-title">
          {{ "NOTIFICATION.CONFIG.KPI_RECAP_TITLE" | translate }}
        </div>
        <p class="notif-config__section-hint">
          {{ "NOTIFICATION.CONFIG.KPI_RECAP_HINT" | translate }}
        </p>

        <label
          *ngFor="let type of visibleKpiRecapNotificationTypes"
          class="notif-config__row"
          [class.notif-config__row--on]="isTypeEnabled(type)"
        >
          <span class="notif-config__row-label">{{
            "NOTIFICATION.TYPE." + type | translate
          }}</span>
          <span class="notif-switch notif-switch--solo">
            <input
              type="checkbox"
              [checked]="isTypeEnabled(type)"
              (change)="toggleType(type)"
            />
            <span class="notif-switch__track" aria-hidden="true"></span>
          </span>
        </label>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="notif-config__footer">
      <button
        type="button"
        class="notif-config__btn notif-config__btn--ghost"
        (click)="closeConfigModal()"
        [disabled]="savingConfig"
      >
        {{ "NOTIFICATION.CONFIG.CLOSE" | translate }}
      </button>
      <button
        type="button"
        class="notif-config__btn notif-config__btn--primary"
        (click)="saveConfig()"
        [disabled]="savingConfig || loadingConfig"
      >
        {{ "NOTIFICATION.CONFIG.SAVE" | translate }}
      </button>
    </div>
  </div>
</div>
